export enum DensityMapControlsEventType {
  TOGGLE_AUTOPILOT = 'control_panel_toggle_autopilot',
  TOGGLE_PLAYING = 'control_panel_toggle_playing',
  SET_PLAYBACK_SPEED = 'control_panel_set_playback_speed',
  TOGGLE_PLAYBACK_REPEAT = 'control_panel_toggle_playback_repeat'
}